import React, { useMemo } from "react";
import Badge from "react-bootstrap/Badge";
import Container from "react-bootstrap/Container";
import { PRMCodes } from "_utils/constants";

const AssistanceColumn = ({ values }) => {
  return (
    <>
      {values != null || values != undefined ? (
        <div style={{ display: "flex", marginTop: -6 }}>
          {values.map((assistance, index) => {
            if (
              PRMCodes.includes(assistance)
            ) {
              return (
                <div
                  style={{
                    display: "flex",
                    marginLeft: index == 0 ? 0 : 5,
                    justifyContent: "left",
                  }}
                >
                  <Badge bg="primary" className="p-2">
                    {assistance}
                  </Badge>
                </div>
              );
            }
          })}
        </div>
      ) : (
        <p style={{ color: Colors.TEXT_COLOR }}>loading</p>
      )}
    </>
  );
};

export default AssistanceColumn;
